import { compose } from 'recompose';
import { queryGetAllPerDiemTicketNumbersGQL } from '../graphql/GetPerDiemTicketNumbersApi';
import { TicketInput } from '../components/TicketInput';

const enhance = compose(queryGetAllPerDiemTicketNumbersGQL);

export default enhance(TicketInput);
